import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { DadosNotaFiscal } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { RespostaNotasFiscaisItens } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Itens";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { NotaFiscalItens } from "./NotaFiscalItens";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { useMenuConsultasPesquisaOrcamento } from "app/components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";
import { useMenuSubConsultasNotaFiscal } from "app/components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/useMenuSubConsultasNotaFiscal";


export type NotaFiscalItensContainerProps = {
    notaFiscalSelecionada: Partial<DadosNotaFiscal>
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
};

export const NotaFiscalItensContainer = (props: NotaFiscalItensContainerProps) => {

    const [dados, setDados] = useState<RespostaNotasFiscaisItens[]>();
    const [mostrarDetalhesTipoEntrega, setMostrarDetalhesTipoEntrega] = useState(false);
    const [itemSelecionado, setitemSelecionado] = useState<RespostaNotasFiscaisItens>();

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosItens = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalSaida.Itens(
                Number(props.notaFiscalSelecionada.Codigo)
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onMostrarDetalhesTipoEntrega = (mostrar: boolean, notaFiscal: RespostaNotasFiscaisItens) => {
        setMostrarDetalhesTipoEntrega(mostrar)
        setitemSelecionado(notaFiscal)
    }

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.remove("Notas Fiscais").map)),
    })

    useMenuSubConsultasNotaFiscal({
        notaFiscalSelecionada: props.notaFiscalSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => props.onVoltar(),
        passos: props.passos
    })

    useEffect(() => {
        passosInterno.current.set("Notas Fiscais", () => props.onVoltar())
        passosInterno.current.set("Itens", () => { })
        onObterDadosItens();
    }, [])


    return <>

        <Breadcrumb2Container
            passos={passosInterno.current.keysToList()}
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={true}
            id="NotaFiscalItensContainer"
            onPassoSelecionado={onPassoSelecionado}
            onBotaoVoltarClicado={() => onVoltar()}
        />


        <NotaFiscalItens
            mostrarDetalhesTipoEntrega={mostrarDetalhesTipoEntrega}
            onMostrarDetalhesTipoEntrega={onMostrarDetalhesTipoEntrega}
            notasFiscais={dados}
            itemSelecionado={itemSelecionado}
        />
    </>
}
